"use strict";
/**
 * Copyright © 2019 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUI = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var mobx_react_lite_1 = require("mobx-react-lite");

var lodash_1 = require("lodash");

var SortableResizableWrapper_1 = __importDefault(require("./SortableResizableWrapper"));

var defaultUI = {
  Wrapper: SortableResizableWrapper_1.default,
  SnapIndicator: 'div'
};

exports.getUI = function (ui) {
  if (ui === void 0) {
    ui = {};
  }

  return __assign(__assign({}, defaultUI), ui);
};

var SortableResizable$ = function SortableResizable$(_a) {
  var children = _a.children,
      ui = _a.ui,
      props = __rest(_a, ["children", "ui"]); // We wabt to activate if nessesary


  var uuid = props.uuid;
  core_1.useActivateOnEffectActivator(uuid);
  var isActive = core_1.useEditContext().isActive;
  var Wrapper = exports.getUI(ui).Wrapper; // @ts-ignore

  return react_1.default.createElement(Wrapper, __assign({
    isEnabled: isActive
  }, core_1.useContextActivator(), props), children);
};

var SortableResizable = lodash_1.flow(mobx_react_lite_1.observer, core_1.withContextActivator('onClick'), core_1.withLocalContextMenu)(SortableResizable$);

var SlateSortableResizable = function SlateSortableResizable(props) {
  var children = props.children,
      uuid = props.uuid,
      useGetMenuOptions = props.useGetMenuOptions,
      rest = __rest(props, ["children", "uuid", "useGetMenuOptions"]);

  return react_1.default.createElement(core_1.PageContextProvider, {
    name: "Flow Container Item",
    id: "flexItem-" + uuid,
    getMenuOptions: useGetMenuOptions()
  }, react_1.default.createElement(SortableResizable, __assign({
    uuid: uuid
  }, rest), children));
};

SlateSortableResizable.displayName = 'SlateSortableResizable';
SlateSortableResizable.defaultProps = {
  onResize: function onResize() {},
  defaultSize: {
    width: '',
    height: ''
  }
};
exports.default = SlateSortableResizable;